/**
 * Driver API Schemas
 *
 * Zod validation schemas for driver-related API operations
 */

import dayjs from "dayjs";
import { z } from "zod";

import { REGEX } from "@/lib/zod";

/**
 * Schema for driver group query arguments
 */
export const DriverGroupArgsSchema = z
  .object({
    from_id: z.string(),
    page_size: z.string().or(z.number()),
    companyId: z.string(),
    status: z.enum(["Nenhum", "0", "1"]),
    shippingCompanyId: z.string(),
    truck_search: z.string(),
    driver_search: z.string()
  })
  .partial();

/**
 * Schema for creating/editing a truck (used in driver edit)
 */
export const createTruckArgsSchema = z.object({
  id: z.string().or(z.number()).optional().nullable(),
  color: z.string().min(1, "Cor é obrigatória"),
  licensePlate: z.string().min(1, "Placa é obrigatória").regex(REGEX.PLATE, "Placa inválida"),
  renavam: z.string().regex(REGEX.RENAVAM, "Renavam inválido").min(1, "Renavam é obrigatório"),
  owner: z.string().optional(), // Proprietário
  shippingCompany: z
    .object({
      id: z.string().nullable()
    })
    .nullable(),
  vehicleModel: z.object({
    id: z.string("Modelo do veículo é obrigatório")
  }),
  brand: z.object({
    id: z.string("Marca é obrigatória").optional()
  }),
  driver: z.object({
    id: z.string()
  }),
  company: z.object({
    id: z.string("Empresa é obrigatória").nullable()
  }),
  implementType: z.string("Tipo de implemento é obrigatório"),
  shaftQuantity: z.number("Quantidade de eixos é obrigatória").min(1, "Quantidade de eixos é obrigatória"),
  grossCapacity: z.number("Capacidade bruta é obrigatória").min(1, "Capacidade bruta é obrigatória"),
  netCapacity: z.number("Capacidade líquida é obrigatória").min(1, "Capacidade líquida é obrigatória"),
  isEnabled: z.boolean(),
  holder: z.string().optional(), // Titular
  name: z.string().optional(),
  cpf: z.string().optional(),
  contact: z.array(
    z
      .object({
        id: z.number().nullable(),
        name: z.string().min(1, "Nome é obrigatório"),
        fone: z.string().min(1, "Telefone é obrigatório"),
        email: z.email("Email inválido")
      })
      .partial()
  )
});

/**
 * Schema for editing a driver
 */
export const EditDriverArgsSchema = z.object({
  id: z.number().nullable(),
  name: z.string(),
  cpf: z.string(),
  cnh: z.string(),
  birthDate: z.string().refine((val) => {
    const brDate = dayjs(val).format("DD/MM/YYYY");

    return dayjs(brDate, "DD/MM/YYYY", true).isValid();
  }, "Formato inválido, esperado DD/MM/YYYY"),
  isEnabled: z.boolean(),
  shippingCompany: z
    .object({
      id: z.string().or(z.number()).optional()
    })
    .optional(),
  company: z
    .object({
      id: z.string({ error: "Empresa é obrigatório" }).or(z.number())
    })
    .optional(),
  contact: z
    .array(
      z.object({
        id: z.string().or(z.number()).nullable(),
        name: z.string(),
        fone: z.string(),
        email: z.string(),
        whatsapp: z.boolean().optional()
      })
    )
    .optional(),
  // truck: z.array(createTruckArgsSchema.omit({ shippingCompany: true, company: true, driver: true, contact: true })).optional()
  // truck: z.array(createTruckArgsSchema.partial()).optional()
  truck: z.array(createTruckArgsSchema.partial()).optional()
});
